import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/accounts/:account_id/organizations', params, query, config)
  },
}
